// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1txGn","boxTitle":"Qualiphy_boxTitle__16yST","box":"Qualiphy_box__2jDTA","toggleWrap":"Qualiphy_toggleWrap__2HOzV"};